import { createServiceStateApi } from './_serviceState';
const api = createServiceStateApi('external-models');
export const { getAllState, getState, patchState, putState, removeState } = api;
export default api;
